import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    if (typeof window.__SENTRY__?.captureException === 'function') window.__SENTRY__.captureException(error);
    console.error('[ErrorBoundary]', error, errorInfo);
    // Stale chunk after a new deploy — hard reload fetches fresh index.html + chunks
    if (error?.name === 'ChunkLoadError' || error?.message?.includes('Loading chunk')) {
      window.location.reload();
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        height:'100vh', display:'flex', flexDirection:'column',
        alignItems:'center', justifyContent:'center',
        background:'#F7F8FA', padding:24, textAlign:'center',
      }}>
        <div style={{fontSize:'3rem', marginBottom:16}}>⚠️</div>
        <h2 style={{
          fontFamily:'Bricolage Grotesque,sans-serif', fontSize:'1.4rem',
          fontWeight:900, color:'#0A2540', marginBottom:8,
        }}>
          Something went wrong
        </h2>
        <p style={{color:'#666', fontSize:'.85rem', marginBottom:24, maxWidth:300, lineHeight:1.6}}>
          An unexpected error occurred. We've been notified and will fix it soon.
        </p>
        <div style={{display:'flex', gap:10}}>
          <button
            onClick={() => this.setState({ hasError:false, error:null })}
            style={{
              background:'#635BFF', color:'#000', border:'none',
              borderRadius:12, padding:'12px 24px', cursor:'pointer',
              fontFamily:'Outfit,sans-serif', fontWeight:700, fontSize:'.88rem',
            }}
          >
            Try Again
          </button>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              background:'#ffffff', color:'#0A2540',
              border:'1px solid #d0cdc6', borderRadius:12,
              padding:'12px 24px', cursor:'pointer',
              fontFamily:'Outfit,sans-serif', fontWeight:600, fontSize:'.88rem',
            }}
          >
            Go Home
          </button>
        </div>
        {process.env.NODE_ENV === 'development' && this.state.error && (
          <details style={{marginTop:24, textAlign:'left', maxWidth:400}}>
            <summary style={{color:'#999', cursor:'pointer', fontSize:'.78rem'}}>
              Error details (dev only)
            </summary>
            <pre style={{
              background:'#ffffff', border:'1px solid #E3E8EF',
              borderRadius:8, padding:12, fontSize:'.8rem',
              color:'#ff3b30', overflow:'auto', marginTop:8, maxHeight:200,
            }}>
              {this.state.error.toString()}
              {'\n'}
              {this.state.errorInfo?.componentStack}
            </pre>
          </details>
        )}
      </div>
    );
  }
}
